/* src/app/modules_v2/booking/components/booking-reports/booking-reports.component.scss */
.contenedor-informes-booking {
  padding: 2rem;
  margin: 0 auto;
}
.contenedor-informes-booking .encabezado-pagina {
  margin-bottom: 2rem;
}
.contenedor-informes-booking .encabezado-pagina h2 {
  margin: 0;
  font-size: 1.75rem;
  color: #333;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.contenedor-informes-booking .encabezado-pagina .texto-secundario {
  color: #666;
  margin: 0;
  font-size: 0.95rem;
}
.contenedor-informes-booking .alerta {
  padding: 1rem;
  margin-bottom: 1.5rem;
  border-radius: 4px;
  border-left: 4px solid;
}
.contenedor-informes-booking .alerta.alerta-peligro {
  background-color: #fef1f0;
  border-color: #d9534f;
  color: #a94442;
}
.contenedor-informes-booking .panel-filtros {
  background: #f5f5f5;
  padding: 1.5rem;
  border-radius: 4px;
  margin-bottom: 2rem;
  border: 1px solid #ddd;
}
.contenedor-informes-booking .panel-filtros .fila-filtros {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
  margin-bottom: 1rem;
}
.contenedor-informes-booking .panel-filtros .grupo-filtro {
  display: flex;
  flex-direction: column;
}
.contenedor-informes-booking .panel-filtros .grupo-filtro label {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: #333;
  font-size: 0.875rem;
}
.contenedor-informes-booking .panel-filtros .grupo-filtro .control-formulario {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 3px;
  font-size: 0.875rem;
  font-family: inherit;
  background-color: white;
  width: 100%;
}
.contenedor-informes-booking .panel-filtros .grupo-filtro .control-formulario:focus {
  outline: none;
  border-color: #e3fd64;
  box-shadow: 0 0 0 2px rgba(227, 253, 100, 0.15);
}
.contenedor-informes-booking .panel-filtros .grupo-filtro .control-formulario:disabled {
  background-color: #f5f5f5;
  color: #aaa;
  cursor: not-allowed;
}
.contenedor-informes-booking .panel-filtros .acciones-filtro {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  justify-content: flex-end;
}
.contenedor-informes-booking .panel-filtros .acciones-filtro .btn {
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  font-weight: 600;
  font-size: 0.875rem;
  transition: all 0.2s;
}
.contenedor-informes-booking .panel-filtros .acciones-filtro .btn.btn-principal {
  background-color: #0066cc;
  color: white;
}
.contenedor-informes-booking .panel-filtros .acciones-filtro .btn.btn-principal:hover {
  background-color: #0052a3;
}
.contenedor-informes-booking .panel-filtros .acciones-filtro .btn.btn-secundario {
  background-color: #6c757d;
  color: white;
}
.contenedor-informes-booking .panel-filtros .acciones-filtro .btn.btn-secundario:hover {
  background-color: #5a6268;
}
.contenedor-informes-booking .panel-filtros .acciones-filtro .btn.btn-exito {
  background-color: #28a745;
  color: white;
}
.contenedor-informes-booking .panel-filtros .acciones-filtro .btn.btn-exito:hover {
  background-color: #218838;
}
.contenedor-informes-booking .cargando {
  text-align: center;
  padding: 3rem;
  color: #666;
  font-size: 1rem;
}
.contenedor-informes-booking .pestanas {
  display: flex;
  gap: 0;
  border-bottom: 2px solid #ddd;
  margin-bottom: 2rem;
  background: white;
}
.contenedor-informes-booking .pestanas .boton-pestana {
  background: none;
  border: none;
  cursor: pointer;
  padding: 1rem 1.5rem;
  font-weight: 600;
  color: #666;
  border-bottom: 3px solid transparent;
  transition: all 0.2s;
  margin-bottom: -2px;
}
.contenedor-informes-booking .pestanas .boton-pestana:hover {
  color: #333;
  background-color: #f9f9f9;
}
.contenedor-informes-booking .pestanas .boton-pestana.activa {
  color: #0066cc;
  border-bottom-color: #0066cc;
}
.contenedor-informes-booking .contenido-pestana {
  animation: fadeIn 0.2s ease-in;
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 768px) {
  .contenedor-informes-booking {
    padding: 1rem;
  }
  .contenedor-informes-booking .encabezado-pagina h2 {
    font-size: 1.25rem;
  }
  .contenedor-informes-booking .panel-filtros .fila-filtros {
    grid-template-columns: 1fr;
  }
  .contenedor-informes-booking .pestanas {
    flex-wrap: wrap;
  }
  .contenedor-informes-booking .pestanas .boton-pestana {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
  }
}
/*# sourceMappingURL=booking-reports.component.css.map */
